import { useEffect, useState, useCallback } from "react";
import { SERVER_URL } from "../../../constants";

export default function useResidentialTimetable(date, campus) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!date || !campus) return;

    setLoading(true);
    setError(null);

    try {
      const res = await fetch(
        `${SERVER_URL}api/timetable/residential?date=${date}&campus=${campus}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer")}`,
          },
        }
      );

      if (!res.ok) throw new Error("Failed to load timetable");

      const json = await res.json();
      setData(json);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [date, campus]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refresh: fetchData };
}